<template>
  <div class="portfolio">
    <Hero/>
    <PortfolioList/>
  </div>

</template>

<script>

  // @ is an alias to /src
  import Hero from '@/components/Hero.vue'
  import PortfolioList from '@/components/PortfolioList.vue'

  export default {
    name: 'portfolio',
    components: {
      Hero,
      PortfolioList
    }
  }

</script>
